import { render, staticRenderFns } from "./delete-br-modal.vue?vue&type=template&id=b8a99a06"
import script from "./delete-br-modal.ts?vue&type=script&lang=ts&external"
export * from "./delete-br-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./delete-br-modal.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8a99a06')) {
      api.createRecord('b8a99a06', component.options)
    } else {
      api.reload('b8a99a06', component.options)
    }
    module.hot.accept("./delete-br-modal.vue?vue&type=template&id=b8a99a06", function () {
      api.rerender('b8a99a06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-input/delete-br-modal/delete-br-modal.vue"
export default component.exports